import React from 'react';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import StatusChip from "./StatusChip";
import DescriptionList from "../shared/DescriptionList";
import DescriptionItem from "../shared/DescriptionItem";


function ShiftProgress(props) {
  const {classes, shift} = props;

  return (
    <section className={classes.detailSection}>
      <Typography className={classes.title} variant={'subheading'}>Progress</Typography>
      <DescriptionList>
        <DescriptionItem term={'Status'}
                         details={(<StatusChip shift={shift}/>)}/>
        <DescriptionItem term={'Pros Found'}
                         details={(
                           <div>
                             <div>
                               {shift.confirmed_pros.length + '/' + shift.required_pros}
                             </div>
                             <ul className={classes.confirmedPros}>
                               {shift.confirmed_pros.map((pro, index) => (
                                 <li key={index}>
                                   {pro.name}
                                 </li>
                               ))}
                             </ul>
                           </div>
                         )}/>
      </DescriptionList>
    </section>
  )
}

const styles = (theme) => ({
  detailSection: {
    marginBottom: theme.spacing.unit * 4
  },
  title: {
    marginBottom: theme.spacing.unit * 2
  },
  confirmedPros: {
    marginTop: theme.spacing.unit,
    paddingLeft: 0,
    listStyle: 'inside',
  },
});


export default withStyles(styles)(ShiftProgress);



// WEBPACK FOOTER //
// ./src/parts/ShiftProgress.js